(() => {
  const titles = {
    merchantwidgetiframe: 'Google store information',
    PBarNextFrame: 'Shopify theme preview',
  };
  const labelFrames = () => {
    let found = 0;
    for (const [id, title] of Object.entries(titles)) {
      const frame = document.getElementById(id);
      if (!frame || frame.tagName !== 'IFRAME') continue;
      found += 1;
      if (!frame.getAttribute('title') && !frame.getAttribute('aria-label') && !frame.getAttribute('aria-labelledby')) {
        frame.setAttribute('title', title);
      }
    }
    return found === Object.keys(titles).length;
  };
  if (labelFrames()) return;
  const observer = new MutationObserver(() => {
    if (labelFrames()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 30000);
})();
